import { combineReducers } from "@reduxjs/toolkit";
import errorSlice from "./errorSlice";

const globalReducers = () =>
  combineReducers({
    errors: errorSlice,
  });

export default globalReducers;
